import { Context, Module } from 'vuex-smart-module';
import { ReserveVehicleState } from '@/store/reserve-vehicle/state';
import { ReserveVehicleGetters } from '@/store/reserve-vehicle/getters';
import { ReserveVehicleMutations } from '@/store/reserve-vehicle/mutations';
import { ReserveVehicleActions } from '@/store/reserve-vehicle/actions';

export type ReserveVehicleModuleContext = Context<Module<ReserveVehicleState, ReserveVehicleGetters, ReserveVehicleMutations, ReserveVehicleActions>>;

export const reserveVehicleModule = new Module({
	state: ReserveVehicleState,
	getters: ReserveVehicleGetters,
	mutations: ReserveVehicleMutations,
	actions: ReserveVehicleActions,
});
